import { useState } from 'react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { Loader2, KeyRound } from 'lucide-react';
import { toast } from 'sonner';
import { useAuth } from '../contexts/AuthContext';

// Bloque C: cambio obligatorio de la contraseña temporal en el primer ingreso
export function FirstPasswordChange({ tempToken, currentPassword, onDone }) {
    const { completeFirstChange } = useAuth();
    const [pw, setPw] = useState('');
    const [pw2, setPw2] = useState('');
    const [saving, setSaving] = useState(false);
    const submit = async (e) => {
        e.preventDefault();
        if (pw !== pw2) { toast.error('Las contraseñas no coinciden'); return; }
        setSaving(true);
        try {
            const u = await completeFirstChange(tempToken, currentPassword, pw);
            toast.success('Contraseña actualizada');
            onDone(u);
        } catch (err) {
            const d = err.response?.data?.detail;
            toast.error(typeof d === 'string' ? d : d?.message || 'No se pudo cambiar la contraseña');
        } finally { setSaving(false); }
    };
    return (
        <form onSubmit={submit} className="space-y-4" data-testid="first-change-form">
            <div className="flex items-start gap-2 rounded-md border border-amber-500/40 bg-amber-500/10 p-3 text-sm">
                <KeyRound className="w-4 h-4 mt-0.5 text-amber-600 dark:text-amber-400" />
                <span>Estás usando una contraseña temporal. Debes crear una nueva para continuar.</span>
            </div>
            <div className="space-y-2">
                <Label htmlFor="new-pw">Nueva contraseña</Label>
                <Input id="new-pw" type="password" value={pw} onChange={e => setPw(e.target.value)} required data-testid="first-change-new" className="input-aviation" />
                <p className="text-[11px] text-muted-foreground">Mínimo 10 caracteres, con mayúscula, minúscula, número y símbolo.</p>
            </div>
            <div className="space-y-2">
                <Label htmlFor="new-pw2">Confirmar contraseña</Label>
                <Input id="new-pw2" type="password" value={pw2} onChange={e => setPw2(e.target.value)} required data-testid="first-change-confirm" className="input-aviation" />
            </div>
            <Button type="submit" className="w-full btn-primary" disabled={saving} data-testid="first-change-submit">
                {saving && <Loader2 className="w-4 h-4 animate-spin mr-2" />}Guardar y entrar
            </Button>
        </form>
    );
}
